import Vue, { CreateElement, RenderContext, VNode } from "vue";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Props {
  hasAppend: boolean;
  hasPrepend: boolean;
  hasSecondPrepend: boolean;
}
export default Vue.extend({
  functional: true,
  name: "BaseInputField",
  props: {
    hasAppend: { type: Boolean, default: false },
    hasPrepend: { type: Boolean, default: false },
    hasSecondPrepend: { type: Boolean, default: false },
  },
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    const { hasPrepend, hasAppend, hasSecondPrepend } = ctx.props;

    return (
      <div staticClass={ctx.data.staticClass} class={["input__box", ctx.data.class]}>
        {ctx.scopedSlots.label && ctx.scopedSlots.label({ classes: { input__label: true } })}
        <div
          staticClass="input-field__wrapper"
          class={{
            "__append-icon": hasAppend,
            "__prepend-icon": hasPrepend && !hasSecondPrepend,
            "__second-prepend": hasSecondPrepend,
          }}
        >
          {ctx.scopedSlots.default && ctx.scopedSlots.default({ classes: { input__field: true } })}
          {ctx.scopedSlots.secondPrependIcon &&
            ctx.scopedSlots.secondPrependIcon({ classes: { "input__icon __second-prepend": true } })}
          {ctx.scopedSlots.prependIcon && ctx.scopedSlots.prependIcon({ classes: { "input__icon __prepend": true } })}
          {ctx.scopedSlots.appendIcon && ctx.scopedSlots.appendIcon({ classes: { "input__icon __append": true } })}
        </div>
        <div staticClass={"d-flex __space-between"}>
          {ctx.scopedSlots.hint && ctx.scopedSlots.hint({})}
          {ctx.scopedSlots.symbolCount && ctx.scopedSlots.symbolCount({})}
        </div>
      </div>
    );
  },
});
